import { Card } from "@rmwc/card";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useBreadcrumbs } from "~/main-layout/BreadcrumbProvider";
import styled from "@emotion/styled";
import { FolderPane } from "./FolderPane";
import Spinner from "~/components/spinner";
import _ from "lodash";
import { StructuralFolder as _StructuralFolder } from "~/gql/types2";
import { FolderDisplay } from "./FolderDisplay";
import { organizeByClient } from "./organizeByClient";
import { filterByNeedsAttention } from "./filterByNeedsAttention";
import {
  ProjectFoldersApiProvider,
  useProjectFoldersPageApi,
} from "./ProjectFoldersPageApi";
import { ProjectFoldersControlArea } from "./ProjectFoldersControlArea";
import { OrganizeBy } from "./types";

const FullPageCard = styled(Card)`
  width: 100%;
  height: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
`;

const ContentArea = styled("div")`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
`;

const LeftContentPane = styled("div")`
  overflow: hidden;
  overflow-y: auto;
  flex-grow: 1;
`;
const RightContentPane = styled("div")`
  overflow: hidden;
  overflow-y: auto;
  overflow-wrap: anywhere;
  flex-shrink: 0;
  flex-basis: 400px;
  background-color: #fff;
  margin-right: 16px;
  padding: 8px;
  border: 1px solid rgba(0, 0, 0, 0.42);
`;

export const ProjectFolders: React.FC = () => {
  useBreadcrumbs([{ text: "Project Folders" }], []);
  const [organizeBy, setOrganizeBy] = useState<OrganizeBy>("Drive");

  const [searchParams] = useSearchParams();
  const needsAttention = searchParams.get("needsAttention") === "true";

  const api = useProjectFoldersPageApi();
  const {
    loading,
    selectedFolder,
    setSelectedFolder,
    setProjectManager,
    topLevelFolders,
  } = api;

  const filtered = needsAttention
    ? filterByNeedsAttention(topLevelFolders)
    : topLevelFolders;

  const folderData =
    organizeBy === "Drive" ? filtered : organizeByClient(filtered);

  return (
    <ProjectFoldersApiProvider api={api}>
      <FullPageCard>
        {loading ? (
          <Spinner open={loading} />
        ) : (
          <>
            <ProjectFoldersControlArea
              organizeBy={organizeBy}
              setOrganizeBy={setOrganizeBy}
              setProjectManager={setProjectManager}
            />
            <ContentArea>
              <LeftContentPane>
                {folderData.map((x) => (
                  <FolderDisplay
                    folder={x}
                    key={x.path}
                    selectable
                    onSelect={setSelectedFolder}
                    selectedFolder={selectedFolder}
                  />
                ))}
              </LeftContentPane>
              <RightContentPane>
                <FolderPane />
              </RightContentPane>
            </ContentArea>
          </>
        )}
      </FullPageCard>
    </ProjectFoldersApiProvider>
  );
};
